import React from 'react';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';

export interface DLORadioButtonProps {
  selected: boolean;
  onPress: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  style?: any;
}

const DLORadioButton: React.FC<DLORadioButtonProps> = ({
  selected,
  onPress,
  disabled = false,
  size = 'medium',
  style,
}) => {
  const sizeStyles = getSizeStyles(size);

  return (
    <TouchableOpacity
      style={[styles.container, style]}
      onPress={onPress}
      disabled={disabled}
      activeOpacity={0.7}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
    >
      <View style={[styles.toggle, styles.toggleFlexBox, sizeStyles.toggle]}>
        <View style={[styles.toggleValue, styles.toggleFlexBox, sizeStyles.toggleValue]}>
          <View style={[
            styles.toggleMargin,
            selected ? styles.toggleMarginSelected : styles.toggleMarginUnselected
          ]}>
            <View style={[
              styles.toggleItem,
              sizeStyles.toggleItem,
              {
                backgroundColor: selected ? '#005CBC' : (disabled ? '#D0D0D0' : '#616161'),
                justifyContent: selected ? 'flex-end' : 'flex-start',
                flexDirection: 'row'
              }
            ]}>
              <View style={[styles.toggleDot, sizeStyles.toggleDot]} />
            </View>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const getSizeStyles = (size: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small':
      return {
        toggle: { height: 24 },
        toggleValue: { height: 18 },
        toggleItem: { width: 24, height: 12, borderRadius: 18 },
        toggleDot: { width: 8, height: 8 },
      };
    case 'large':
      return {
        toggle: { height: 40 },
        toggleValue: { height: 30 },
        toggleItem: { width: 40, height: 20, borderRadius: 30 },
        toggleDot: { width: 12, height: 12 },
      };
    case 'medium':
    default:
      return {
        toggle: { height: 32 },
        toggleValue: { height: 24 },
        toggleItem: { width: 32, height: 16, borderRadius: 24 },
        toggleDot: { width: 10, height: 10 },
      };
  }
};

const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  toggleFlexBox: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  toggleDot: {
    borderRadius: 999,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  toggleItem: {
    padding: 3,
    overflow: 'hidden',
  },
  toggleMargin: {
    paddingHorizontal: 0,
    paddingVertical: 1,
  },
  toggleMarginSelected: {
    justifyContent: 'flex-end',
  },
  toggleMarginUnselected: {
    justifyContent: 'flex-start',
  },
  toggleValue: {
    // Height set by size styles
  },
  toggle: {
    // Height set by size styles
  },
});

export default DLORadioButton;
